module.exports = __webpack_public_path__ + "static/media/backlight2.9576a707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/backlight2.jpg
// module id = 313
// module chunks = 0